import {
  selectIsAssessmentActive,
  useAssessmentStore,
} from "@/features/tutor/store/useAssessmentStore";
import { useUIStore } from "@/features/tutor/store/useUIStore";
import { useChatSettingsStore } from "@/features/tutor/store/useChatSettingsStore";
import { useViewport } from "@/hooks/useViewport";
import { useTypedChatEnabled } from "@/hooks/useRuntimeFlags";
import {
  resolveInputMode,
  type InputMode,
} from "@/features/tutor/utils/chatSettingsPersistence";

export interface ChatAvailability {
  chatAvailable: boolean;
  renderedMode: InputMode;
}

export const useChatAvailability = (): ChatAvailability => {
  const typedChatEnabled = useTypedChatEnabled();
  const inAssessment = useUIStore((s) => !!s.activeAssessmentModal);
  const inAssessmentSlice = useAssessmentStore(selectIsAssessmentActive);
  const inputMode = useChatSettingsStore((s) => s.inputMode);
  const { isMobilePortrait, isMobileLandscape } = useViewport();

  const chatAvailable =
    typedChatEnabled &&
    !inAssessment &&
    !inAssessmentSlice &&
    !isMobilePortrait &&
    !isMobileLandscape;

  return {
    chatAvailable,
    renderedMode: resolveInputMode(inputMode, chatAvailable),
  };
};
